import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { CITIES_PAGE } from '../../api/citiesPage';
import Cities from '../../pages/cities';
interface Cards {
  text: string;
  name: string;
  slug: string;
  showSnippet: boolean;
  index: number;
  setShowSnippet: React.Dispatch<React.SetStateAction<boolean>>;
}
const CardSnippet = ({
  text,
  name,
  slug,
  showSnippet,
  setShowSnippet,
  index
}: Cards) => {
  const router = useRouter();
  return (
    <>
      <div
        onMouseEnter={() => {
          if (!showSnippet) {
            setShowSnippet(true);
          }
        }}
        className={`absolute left-0 ${
          index % 2 === 0
            ? 'bg-gradient-to-t from-[#1F2C5B] w-full '
            : 'bg-gradient-to-t from-[#FF4545] w-full '
        } ${showSnippet && 'right-0'} bottom-0 ${
          !showSnippet && 'rounded-[5px] h-[20%] flex items-center'
        } py-1 xl:py-2 px-2 lg:px-4 hover:cursor-pointer`}
        onClick={() => {
          if (!showSnippet) {
            setShowSnippet(!setShowSnippet);
          } else {
            router.push(`/${slug}`);
          }
        }}
      >
        <div
          className={` bottom-0 left-0 text-[#ffffff]   text-lg  lg:text-[20px] font-[600] ${
            showSnippet && 'width-[100%]'
          }`}
        >
          {name}
        </div>

        {showSnippet && (
          <div
            className={` w-[100%] text-[#FFFFFF]  text-base lg:text-[18px] 2xl:text-[19px] font-[400] ${
              showSnippet && 'pb-2'
            } `}
          >
            {text}
          </div>
        )}
      </div>
    </>
  );
};
export default CardSnippet;
